import React, { FC } from 'react';
import { IConferenceSpeaker } from '../../event/eventInterface';
import { Avatar, Chip } from '@getgo/chameleon-web/react';
import { SpeakerUtils } from '../../utils/speakerUtils';
import EventTabEnum from '../../enum/eventTabEnum';

export interface ConferenceSpeakerProps {
  speaker: IConferenceSpeaker;
  handleEventSpeakerChange?: (index: number, speakerId: string) => void;
}

const ConferenceSpeaker: FC<ConferenceSpeakerProps> = ({ speaker, handleEventSpeakerChange }) => (
  <div key={speaker.id} className="conference-speaker">
    <Chip
      size="medium"
      avatar={
        speaker.imgsrc ? (
          <Avatar size="xsmall" variant="primary">
            <img alt={speaker.name} src={speaker.imgsrc} />
          </Avatar>
        ) : (
          <Avatar size="xsmall" variant="primary">
            {SpeakerUtils.getInitials(speaker.name)}
          </Avatar>
        )
      }
      onClick={() => handleEventSpeakerChange?.(EventTabEnum.Speakers, speaker.id)}
    >
      {speaker.name}
    </Chip>
  </div>
);

export default ConferenceSpeaker;
